/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-trailing-spaces */
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from 'react-helmet';
import {
  TURY_MINKS_TITLE,
  TURY_MINKS_DESCRIPTION,
} from '../../Utils/Constants/SEO';
import ToursResultFunc from '../ToursResult/ToursResultFunc';
import { TURKEY_NAME } from '../../Utils/Constants/GlobalConstants';
import { getCountry } from '../../Utils/CommonUtils';

class TuryIzMinska extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getText = () => (
    <div>
      <div className="content_block">
        <h1 className="text_h1">
          Туры с вылетом из Минска — Ваш идеальный отдых начинается здесь!
        </h1>
        <p className="text_p">
          Ищете путешествие мечты без лишних хлопот? Отправляйтесь в тур с
          вылетом из Минска и откройте для себя мир без границ! Мы собрали все
          варианты туров от ведущих туроператоров на сайте tourhunter.by с
          прямыми рейсами из Минска, экономя ваше время и силы. Выбирайте
          направление, даты и состав туристов, а мы позаботимся обо всём
          остальном!
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">
          Почему стоит забронировать тур с вылетом из Минска на сайте
          tourhunter.by?
        </h2>
        <p className="text_p">
          Удобство: Никаких поездок в офис - все можно сделать на сайте в пару
          кликов.
        </p>
        <p className="text_p">
          Любой бюджет: Горящие туры, luxury-отдых, семейные и экскурсионные
          туры.
        </p>
        <p className="text_p">
          Поддержка 24/7: Помощь менеджеров на всех этапах путешествия для
          действующих клиентов.
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Топ-направления</h2>
        <p className="text_p">
          Пляжный релакс: Турция, Египет, ОАЭ, Таиланд, Мальдивы.
        </p>
        <p className="text_p">Активный отдых: Грузия.</p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Спецпредложения</h2>
        <p className="text_p">Скидки до 30% на раннее бронирование туров!</p>
        <p className="text_p">Беспроцентная рассрочка на путешествия мечты.</p>
        <p className="text_p">
          Эксклюзивные туры для влюбленных пар и семей с детьми.
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Как это работает?</h2>
        <p className="text_p">
          1. Выберите направление и даты на сайте tourhunter.by
        </p>
        <p className="text_p">2. Выбирайте подходящий тур</p>
        <p className="text_p">
          3. Оплатите онлайн и готовьтесь к незабываемым впечатлениям!
        </p>
      </div>
    </div>
  );

  render() {
    const isSnap = navigator.userAgent === 'ReactSnap';

    return (
      <div className="content">
        <Helmet>
          <title>{TURY_MINKS_TITLE}</title>
          <meta name="description" content={TURY_MINKS_DESCRIPTION} />
          <link rel="canonical" href="https://tourhunter.by/tury-iz-minska/" />

          <meta property="og:site_name" content="TourHunter.by" />
          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content="https://tourhunter.by/tury-iz-minska/"
          />
          <meta property="og:title" content={TURY_MINKS_TITLE} />
          <meta property="og:description" content={TURY_MINKS_DESCRIPTION} />
          <meta
            property="og:image"
            content="https://tourhunter.by/file/binoculars-logo.png"
          />
        </Helmet>
        {!isSnap && <ToursResultFunc countryFilter={getCountry(TURKEY_NAME)} />}

        <div className="container">{this.getText()}</div>
      </div>
    );
  }
}

export default TuryIzMinska;
